"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setLogger = exports.getLogger = void 0;
const VoidLogger_1 = require("./VoidLogger");
let logger = new VoidLogger_1.VoidLogger();
const getLogger = () => logger;
exports.getLogger = getLogger;
const setLogger = (newLogger) => (logger = newLogger);
exports.setLogger = setLogger;
//# sourceMappingURL=SingletonLoggerInstance.js.map